<template>
  <v-container fluid>
<!--    <v-layout align-center justify-center fill-height>-->
<!--      <v-flex xs12 sm8 md5>-->
<!--        <img src="../../static/img/doe-logo.png" alt="">-->
<!--        <div style="font-size: 2.5rem; font-weight: bold; margin: 10px">SYSTEM UPDATE IN PROGRESS</div>-->
<!--        <div style="font-size: 1.5rem; margin: 10px">We apologize for any inconvenience this may cause. Thank you for your patience.</div>-->
<!--        <div style="margin: 10px">Last Updated: 11/03/2020</div>-->
<!--      </v-flex>-->
<!--    </v-layout>-->
    <v-layout align-center justify-center fill-height>
      <v-flex xs12 sm8 md5>
        <v-card class="elevation-12">
          <v-toolbar dark color="primary">
            <!-- Change Version # Below >-->
            <v-toolbar-title>Branch: demo-05-09-1155</v-toolbar-title>
            <v-toolbar-title>Commit: f31315d8</v-toolbar-title>
          </v-toolbar>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
/* eslint-disable indent */
  export default {
    name: 'Version'
  };
</script>
<style scoped>
  img {
    height: 15vh;
  }
</style>



// WEBPACK FOOTER //
// version.vue